import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const SiteSelectProject = () => {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");

    if (!userRole || userRole !== "site") {
      navigate("/");
    } else {
      console.log("Fetching projects for userId:", userId);

      fetch(`/api/projects?user_id=${userId}`)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Failed to fetch projects: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          console.log("Fetched raw data:", data);
          
          // 对于site用户，后端已经根据allowedProjects进行了正确的过滤
          // 不需要前端再次过滤，直接使用后端返回的数据
          console.log("Projects for site user:", data);
          setProjects(data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching projects:", error);
          setLoading(false);
        });
    }
  }, [navigate, userId]);

  const handleProjectSelect = (project) => {
    localStorage.setItem(
      "selectedProject",
      JSON.stringify({
        id: project._id,
        name: project.name,
        description: project.description,
      })
    );
    navigate(`/site_report?projectId=${project._id}`);
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <p>Loading projects...</p>
      </div>
    );
  }

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2>Select a Project</h2>
      <div style={{ maxWidth: "800px", margin: "0 auto", padding: "20px" }}>
        {projects.length > 0 ? (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
              gap: "20px",
            }}
          >
            {projects.map((project) => (
              <button
                key={project._id}
                onClick={() => handleProjectSelect(project)}
                style={{
                  padding: "20px",
                  margin: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  backgroundColor: "white",
                  cursor: "pointer",
                  textAlign: "left",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  transition: "transform 0.2s",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "translateY(-2px)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "translateY(0)")
                }
              >
                <h3 style={{ margin: "0", color: "#333" }}>{project.name}</h3>
                <p style={{ margin: "0", color: "#666", fontSize: "14px" }}>
                  {project.description}
                </p>
                <span
                  style={{
                    padding: "4px 8px",
                    borderRadius: "4px",
                    backgroundColor:
                      project.status === "active" ? "#e6f4ea" : "#f8d7da",
                    color:
                      project.status === "active" ? "#34a853" : "#dc3545",
                    fontSize: "12px",
                    alignSelf: "flex-start",
                  }}
                >
                  {project.status}
                </span>
              </button>
            ))}
          </div>
        ) : (
          <p>No projects available for you.</p>
        )}
      </div>
    </div>
  );
};

export default SiteSelectProject; 